module.exports = __webpack_public_path__ + "img/powered-by-selgem.a8ced0de.png";